module.exports = {"unverified":"Pending Valuation","new":"Pending Valuation","need ess":"Pending Terms Approval","ess approval":"Pending Terms Approval","ptd conditions":"PTD Conditions","final approval":"Docs in Progress","needs docs":"Docs in Progress","docs drawn":"Pending Funding","to be funded":"Pending Funding","funded":"Funded","active":"Active","paid":"Paid","on hold":"On Hold"}


//////////////////
// WEBPACK FOOTER
// ./src/components/my_deals/resources/CategoryPresentation.json
// module id = u2v0
// module chunks = 1